import * as React from "react";
import Svg, { Path, G, Defs, LinearGradient, Stop } from "react-native-svg";

function OrderNotCancelled(props) {
  return (
    <Svg width={210} height={163} viewBox="0 0 210 163" fill="none" {...props}>
      <Path
        d="M22.057 16.32c-1.365.566-2.766 1.292-3.516 2.564-.794 1.345-.699 3.014-.551 4.57 1.289 13.49 4.684 27.838-1.18 40.059-2.845 5.928-7.606 10.679-11.392 16.063C1.632 84.96-1.227 91.682.531 98.016c2.147 7.74 10.159 12.03 15.56 17.986 3.534 3.894 6.013 8.626 9.311 12.723 3.298 4.097 7.818 7.706 13.083 7.946 7.573.348 13.734-6.184 21.159-7.697 7.606-1.549 15.265 2.393 21.433 7.113 6.168 4.719 11.777 10.436 18.963 13.383 7.936 3.256 16.882 2.758 25.237 4.715 7.606 1.783 14.609 5.576 22.16 7.598 7.552 2.022 16.403 1.899 22.253-3.265 7.626-6.754 7.026-18.784 11.896-27.718 4.524-8.301 13.379-13.257 19.339-20.595 10.725-13.208 10.375-33.396 1.268-47.76-9.107-14.365-25.602-23.063-42.469-25.327-7.607-1.02-15.439-.88-22.752-3.2C117.398 27.713 105.749 5.48 85.765.854 73.064-2.082 60.71 3.002 49.889 9.26c-9.391 5.433-18.056 3.01-27.83 7.06z"
        fill="#F2F2F2"
      />
      <Path
        d="M46.515 61.696s-6.577 6.207-13.636 6.392a13.7 13.7 0 00-8.165 2.904 23.044 23.044 0 00-3.052 2.904"
        stroke="#535461"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        d="M17.21 74.049c.948-.482 4.567-.162 4.567-.162s-1.877 3.112-2.825 3.594a1.928 1.928 0 11-1.734-3.432h-.008zM21.02 68.547c1.058.112 3.922 2.347 3.922 2.347s-3.276 1.592-4.325 1.482a1.927 1.927 0 01.403-3.83zM30.054 64.113c.856.63 2.2 4.006 2.2 4.006s-3.624-.276-4.48-.904a1.927 1.927 0 012.28-3.102zM37.645 62.299c.95.476 2.846 3.577 2.846 3.577s-3.619.34-4.569-.135a1.927 1.927 0 111.723-3.442zM26.955 74.403c.316-1.015-.609-4.53-.609-4.53s-2.752 2.374-3.068 3.39a1.929 1.929 0 002.011 2.574 1.927 1.927 0 001.666-1.434zM35.806 72.162c0-1.064-1.936-4.14-1.936-4.14s-1.916 3.084-1.914 4.151a1.927 1.927 0 103.854-.011h-.004zM44.11 68.817c.177-1.049-1.21-4.408-1.21-4.408s-2.411 2.721-2.586 3.77a1.928 1.928 0 003.796.64v-.002z"
        fill="#FFB800"
      />
      <Path
        d="M55.062 45.258S47.14 40.906 44.785 34.24a13.7 13.7 0 00-5.274-6.878 23.036 23.036 0 00-3.708-2.004"
        stroke="#535461"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        d="M34.3 21.167c.75.753 1.557 4.297 1.557 4.297s-3.539-.828-4.288-1.584a1.926 1.926 0 012.73-2.713zM40.707 23.1c.22 1.04-1.027 4.453-1.027 4.453s-2.519-2.618-2.738-3.661a1.926 1.926 0 113.767-.794l-.002.002zM47.702 30.344c-.335 1.008-3.135 3.326-3.135 3.326s-.852-3.532-.517-4.542a1.929 1.929 0 113.662 1.216h-.01zM51.765 37.002c-.16 1.05-2.529 3.808-2.529 3.808s-1.437-3.338-1.277-4.388a1.927 1.927 0 113.806.578v.002zM36.957 30.55c1.063-.012 4.124-1.973 4.124-1.973s-3.105-1.889-4.169-1.877a1.927 1.927 0 10.045 3.854v-.004zM41.805 38.285c1.01-.33 3.344-3.116 3.344-3.116s-3.529-.873-4.538-.543a1.928 1.928 0 101.194 3.661v-.002zM47.548 45.158c1.052-.154 3.823-2.505 3.823-2.505s-3.33-1.457-4.38-1.303a1.928 1.928 0 10.56 3.81l-.003-.002z"
        fill="#FFB800"
      />
      <Path
        d="M109.582 150.839c38.527 0 69.76-31.233 69.76-69.76 0-38.528-31.233-69.761-69.76-69.761-38.528 0-69.761 31.233-69.761 69.76 0 38.528 31.233 69.761 69.761 69.761z"
        fill="url(#prefix__paint0_linear)"
      />
      <Path
        d="M109.581 149.683c37.889 0 68.605-30.715 68.605-68.604 0-37.89-30.716-68.605-68.605-68.605-37.89 0-68.604 30.715-68.604 68.605 0 37.889 30.715 68.604 68.604 68.604z"
        fill="#E40046"
      />
      <Path
        d="M109.582 135.615c30.119 0 54.536-24.417 54.536-54.537 0-30.12-24.417-54.536-54.536-54.536-30.12 0-54.537 24.417-54.537 54.537 0 30.119 24.417 54.536 54.537 54.536z"
        fill="#fff"
      />
      <Path
        opacity={0.3}
        d="M111.123 36.177h-3.083v48.178h3.083V36.177z"
        fill="#535461"
      />
      <G opacity={0.1} fill="#000">
        <Path
          opacity={0.1}
          d="M156.41 79.922h-43.552v3.854h43.552v-3.854zM82.11 65.503l-1.789 3.414 27.404 14.35 1.788-3.414-27.404-14.35z"
        />
        <Path
          opacity={0.1}
          d="M109.582 87.63a5.782 5.782 0 10-.001-11.563 5.782 5.782 0 00.001 11.564z"
        />
      </G>
      <Path
        d="M156.41 79.151h-43.553v3.855h43.553V79.15zM108.307 80.421l-20.49 23.174 2.887 2.553 20.49-23.174-2.887-2.553z"
        fill="#535461"
      />
      <Path
        d="M109.581 86.86a5.781 5.781 0 100-11.562 5.781 5.781 0 000 11.562z"
        fill="#535461"
      />
      <Path
        opacity={0.1}
        d="M59.28 87.63c0-30.12 24.416-54.536 54.537-54.536A54.447 54.447 0 01157.4 54.839c-9.281-16.866-27.203-28.297-47.823-28.297-30.12 0-54.536 24.416-54.536 54.537A54.294 54.294 0 0066 113.87a54.287 54.287 0 01-6.72-26.24z"
        fill="#000"
      />
      <Path
        d="M159.971 40.96c-.647-.622-6.097 3.47-6.097 3.47s-1.941.354-1.478 1.685c.462 1.332-2.033 8.79-2.033 8.79l-1.016-1.42c.098-1.667-.36-2.849-.807-3.585a6.188 6.188 0 00-.11-.171l.177-.062c-.067-.91-1.522-2.295-2.295-2.974v-.292c.048-1.087.484-2.234 0-3.219-.547-1.123-2.149-1.688-2.284-2.921-.081-.736.417-1.401.636-2.11.524-1.696-.564-3.427-1.605-4.887a6.833 6.833 0 00-1.274-1.469 6.175 6.175 0 00-1.53-.817c-1.524-.617-3.083-.927-4.656-1.349-1.509-.4-2.9-.591-4.432-.088a2.178 2.178 0 00-.964.552c-.364.41-.412.991-.651 1.479-.385.784-1.216 1.252-1.95 1.755-.734.503-1.471 1.193-1.474 2.06 0 1.232 1.406 2.006 1.877 3.153.439 1.068 0 2.257-.245 3.382a2.279 2.279 0 00-.029 1.116c.097.275.243.53.432.751.291.386.603.744.913 1.11l-.143.056c-2.586-.266-4.249 3.018-4.249 3.018.12.025.233.054.345.087l-.11.142a14.032 14.032 0 00-1.898 3.32l-2.12 2.841s-.462-7.103.648-8.7c1.11-1.598-1.016-2.575-1.016-2.575s-4.625-5.15-5.267-4.706c-.641.443 1.571 6.038 3.512 6.926 0 0 .192 1.775-.193 2.93-.233.73-1.478 8.434-1.478 8.434s-1.108 6.48 3.973 3.276c3.302-2.077 5.435-5.654 6.522-7.901.076-.158.147-.309.214-.453.05.238.084.48.102.723l.193 7.425a11.288 11.288 0 01-1.168 5.303l-2.265 4.593.253.077-.152.22c-1.492 2.194-4.028 7.13 1.192 9.644l6.938.889-.37 1.775s-2.864 5.415-3.696 9.144a27.414 27.414 0 01-2.403 6.57l.214.113a4.38 4.38 0 00-.135.156 3.347 3.347 0 00-.802 1.68l-.94 1.334s-.37 5.504.37 6.837c.404.729 1.748 1.191 2.89 1.461 1.696.403 3.064-1.349 2.164-2.792l-.011-.02h-.017c-.193-.896-.783-3.677-.59-4.733.054-.3.104-.599.129-.903.046-.401.168-.788.358-1.143.031-.06.064-.118.097-.176l.1.043c.31.133.617.258.908.368-.451.41-.771 1.26-.386 3.008 0 0 .037 4.373.37 5.061.334.688 4.064 1.597 4.712.888.647-.709-.416-3.153-.416-3.153l-.033.023c-.214-1.416-.478-3.952.171-4.95.263-.403.517-.819.744-1.209l.141-.24c1.206.601 2.482 1.054 3.18.74 0 0 3.048-7.104 2.863-7.99-.185-.887 4.712-10.921 4.712-10.921s4.157-4.625-.923-7.812c-1.613-1.016-2.789-1.698-3.642-2.159l-.715-3.738a13.653 13.653 0 01.193-5.909l.77-2.94.064-.251s1.941-3.995 1.848-5.86c-.007-.145.009-.29.048-.43.021.089.045.181.07.277a35.687 35.687 0 002.008 5.658c1.474 3.327 3.661 3.063 4.86 2.59a1.666 1.666 0 001.023-1.198c.432-2.07 1.617-7.869 1.692-9.47.067-1.252.222-2.498.463-3.729 3.04-1.779 5.627-4.885 4.979-5.508z"
        fill="url(#prefix__paint1_linear)"
      />
      <Path
        d="M137.349 97.852s-.407.815-.964 1.794c-.218.385-.46.8-.709 1.198-.881 1.409 0 5.897 0 5.897l-1.927.264-1.927-.963-.353-3.257v-2.382l2.197-2.457.964-1.064 2.719.97z"
        fill="#F8BDC5"
      />
      <Path
        opacity={0.1}
        d="M137.349 97.852s-.407.815-.964 1.794a23.883 23.883 0 01-2.463-1.515l-.169-.12-.091-.065.964-1.064 2.723.97z"
        fill="#000"
      />
      <Path
        d="M146.771 81.39s-4.666 9.947-4.488 10.827c.177.881-2.729 7.923-2.729 7.923-.663.312-1.881-.137-3.03-.733a23.808 23.808 0 01-2.505-1.541l-.169-.12-.103-.073 7.659-21.213-6.776-4.97-.501-.369-3.029-2.235 9.25 1.673s.321-.04 2.023.911c.817.457 1.952 1.141 3.521 2.17 4.835 3.174.877 7.75.877 7.75z"
        fill="#2F2E41"
      />
      <G opacity={0.03}>
        <Path
          opacity={0.08}
          d="M146.771 81.39s-4.666 9.947-4.488 10.827c.177.881-2.729 7.923-2.729 7.923-.663.312-1.881-.137-3.03-.733a23.808 23.808 0 01-2.505-1.541l-.169-.12-.103-.073 7.659-21.213-6.776-4.97-.501-.369-3.029-2.235 9.25 1.673s.321-.04 2.023.911c.817.457 1.952 1.141 3.521 2.17 4.835 3.174.877 7.75.877 7.75z"
          fill="#000"
        />
      </G>
      <Path
        d="M132.596 99.611s-2.289-.353-1.495 3.346c0 0 .035 4.336.353 5.01.318.675 3.873 1.584 4.488.881.615-.704-.397-3.124-.397-3.124s-2.596 1.892-3.301-.133c-.706-2.025.352-5.98.352-5.98z"
        fill="#5D3E53"
      />
      <Path
        d="M131.011 98.908c-.25.238-.453.52-.6.833a3.282 3.282 0 00-.341 1.133c-.023.3-.071.599-.121.896-.22 1.254.622 4.972.622 4.972l-3.345.528-1.232-1.32-.264-2.904a10.5 10.5 0 00.528-3.084c0-.757.386-1.434.771-1.927.262-.33.561-.626.893-.884 0 0 3.794 1.14 3.089 1.757z"
        fill="#F8BDC5"
      />
      <Path
        opacity={0.1}
        d="M131.011 98.908c-.25.238-.453.52-.6.832a50.976 50.976 0 01-3.333-1.688l-.041-.021c.261-.33.561-.626.892-.885 0 0 3.787 1.145 3.082 1.762z"
        fill="#000"
      />
      <Path
        d="M141.839 78.75s-2.199 4.138-3.61 7.57c-.925 2.255-2.837 7.624-4.047 11.043l-.177.505c-.532 1.512-.887 2.536-.887 2.536a2.283 2.283 0 01-.691-.103 7.636 7.636 0 01-.69-.223l-.28-.106a16.865 16.865 0 01-.865-.364c-1.399-.625-2.891-1.438-3.432-1.735l-.204-.113a27.911 27.911 0 002.295-6.52c.792-3.696 3.521-9.057 3.521-9.057l.352-1.761-6.602-.881c-4.974-2.486-2.557-7.387-1.137-9.562.242-.378.504-.743.784-1.093l5.283 1.156s.832.266 2.682 1.085l.85.386c1.037.476 2.312 1.088 3.854 1.875 5.199 2.628 3.001 5.363 3.001 5.363z"
        fill="#2F2E41"
      />
      <Path
        d="M130.538 106.478a1.871 1.871 0 01-.98 2.715 1.874 1.874 0 01-1.082.052c-1.081-.268-2.362-.727-2.748-1.449-.703-1.32-.352-6.778-.352-6.778l.925-1.364s-.484 6.03.661 6.552c1.144.522 3.565.245 3.565.245l.011.027z"
        fill="#5D3E53"
      />
      <Path
        d="M131.475 29.932a2.06 2.06 0 00-.925.549c-.347.404-.385.983-.62 1.466-.367.771-1.157 1.243-1.858 1.735-.702.491-1.401 1.183-1.405 2.042 0 1.222 1.349 1.99 1.788 3.124.419 1.06 0 2.238-.233 3.353-.097.362-.106.741-.027 1.107.092.27.232.523.413.745.849 1.157 1.905 2.182 2.474 3.498.432 1 .551 2.104.665 3.19.164 1.56.327 3.15.031 4.692a.472.472 0 000 .283c.05.088.13.157.225.193a4.626 4.626 0 006.261-2.313c.386-.873.534-1.927 1.297-2.493a.649.649 0 01.31-.141c.18.005.355.063.501.168.991.535 2.192.55 3.296.331.667-.133 1.349-.37 1.79-.89.869-1.033.385-2.577.443-3.924.047-1.077.461-2.214 0-3.19-.52-1.113-2.048-1.672-2.175-2.89-.077-.728.397-1.39.607-2.09.499-1.683-.538-3.398-1.529-4.845a6.697 6.697 0 00-1.212-1.455 5.814 5.814 0 00-1.457-.81c-1.451-.61-2.931-.919-4.432-1.335-1.437-.41-2.761-.601-4.228-.1z"
        fill="#2F2E41"
      />
      <Path
        d="M138.846 55.073h-5.107v-8.275c.152-.795.241-1.6.266-2.41v-.828c-.048-.986-.252-1.971-.788-2.573-1.409-1.584 4.577-1.32 4.577-1.32.184.728.422 1.44.713 2.132a12.994 12.994 0 001.715 3.02 6.986 6.986 0 002.326 1.979c3.515 1.761-3.702 8.275-3.702 8.275z"
        fill="#F8BDC5"
      />
      <Path
        opacity={0.1}
        d="M138.501 41.799a4.672 4.672 0 01-4.502 1.761c-.048-.986-.252-1.971-.788-2.573-1.408-1.584 4.577-1.32 4.577-1.32.184.728.422 1.44.713 2.132z"
        fill="#000"
      />
      <Path
        d="M134.795 43.367a4.666 4.666 0 100-9.331 4.666 4.666 0 000 9.331zM154.16 46.711a27.821 27.821 0 00-.439 3.696c-.071 1.586-1.2 7.337-1.613 9.389a1.629 1.629 0 01-.975 1.189c-1.145.468-3.226.73-4.625-2.567a36.498 36.498 0 01-1.914-5.608c-.171-.645-.3-1.3-.385-1.962l3.083-1.672c.291.271.536.587.729.934.426.73.863 1.902.771 3.554l.963 1.409s2.376-7.395 1.927-8.715c-.449-1.32 1.409-1.672 1.409-1.672s5.193-4.047 5.81-3.433c.617.615-1.836 3.697-4.741 5.458zM128.899 50.232a21.04 21.04 0 01-.829 2.023c-1.037 2.23-3.068 5.781-6.213 7.836-4.841 3.168-3.785-3.257-3.785-3.257s1.185-7.64 1.409-8.362c.353-1.145.175-2.904.175-2.904-1.848-.88-3.96-6.425-3.345-6.866.615-.441 5.01 4.665 5.01 4.665s2.026.964.964 2.554c-1.062 1.59-.617 8.625-.617 8.625l2.037-2.811a14.038 14.038 0 011.81-3.292c.385-.526.655-.844.655-.844l2.729 2.633z"
        fill="#F8BDC5"
      />
      <Path
        opacity={0.1}
        d="M148.023 50.11c-.648.24-3.155 1.25-3.433 2.698-.171-.645-.3-1.3-.385-1.962l3.083-1.672c.293.271.541.587.735.936zM128.899 50.231a21.05 21.05 0 01-.829 2.024c-.12-.871-.611-3.099-2.555-3.818.385-.526.655-.844.655-.844l2.729 2.638zM138.846 55.072h-5.107v-8.275c.152-.794.241-1.6.266-2.408 1.05 1.013.79 2.584.79 2.584l2.729 6.166 1.322-5.451-.439-.704 1.811-2.154a6.986 6.986 0 002.326 1.979c3.519 1.75-3.698 8.263-3.698 8.263zM142.453 71.97s-4-.319-7.471-.469l-.349-.015c-.493-.02-.963-.035-1.424-.047-3.368-.08-7.178-1.258-7.826-1.464.243-.377.506-.74.787-1.089l5.282 1.156s.832.266 2.682 1.085l-3.035-2.241 9.25 1.673s.322-.04 2.024.911l.08.5z"
        fill="#000"
      />
      <Path
        d="M138.846 48.031l-.439-.703 1.954-2.338s4.029 1.975 5.085 1.542c0 0 2.554 2.12 2.641 3.345 0 0-3.697 1.231-3.61 3.084.087 1.851-1.754 5.808-1.754 5.808l-.77 3.164a14.08 14.08 0 00-.193 5.858l.703 3.918s-5.546-.44-9.25-.528c-3.704-.088-7.922-1.495-7.922-1.495l2.16-4.546a11.56 11.56 0 001.114-5.257l-.193-7.36s-.175-3.696-3.083-4.313c0 0 1.584-3.257 4.047-2.993 0 0 3.588-1.497 4.654-.485 1.066 1.011.803 2.598.803 2.598l2.729 6.166 1.324-5.465z"
        fill="#FFB800"
      />
      <Path
        opacity={0.1}
        d="M131.429 37.74c.707 0 1.262-.75 1.97-.71.366.018.68.252.982.462a12.01 12.01 0 003.76 1.734c.522.139 1.075.243 1.6.116.524-.128 1.015-.54 1.075-1.078a1.826 1.826 0 00-.093-.7 8.647 8.647 0 00-3.765-4.97c-.732-.448-1.627-.791-2.438-.51-.732.253-1.204.939-1.734 1.503-.4.423-.853.791-1.349 1.095-.386.233-.964.385-1.185.813-.419.798.239 2.238 1.177 2.245z"
        fill="#000"
      />
      <Path
        d="M131.429 37.565c.707 0 1.262-.75 1.97-.711.366.019.68.252.982.462a12.011 12.011 0 003.76 1.735c.522.138 1.075.242 1.6.115.524-.127 1.015-.54 1.075-1.077a1.826 1.826 0 00-.093-.7 8.647 8.647 0 00-3.765-4.97c-.732-.449-1.627-.792-2.438-.51-.732.252-1.204.938-1.734 1.503-.4.423-.853.79-1.349 1.095-.386.233-.964.385-1.185.813-.419.805.239 2.235 1.177 2.245z"
        fill="#2F2E41"
      />
      <Path
        opacity={0.05}
        d="M129.295 57.669s4.313 1.584 7.131.352l1.408.089s2.342 1.642 4.818.907M149.717 55.028s-.704 1.673-.353 2.2l.353-2.2zM121.637 54.5s.353 1.673 0 2.201v-2.2z"
        fill="#000"
      />
      <Path
        d="M194.639 92.616s-8.063 8.063-3.511 20.026c4.552 11.964-7.801 31.859-7.801 31.859s.133-.019.386-.062c16.559-2.923 24.786-21.861 15.578-35.93-3.432-5.232-6.242-11.368-4.652-15.893z"
        fill="#FFB800"
      />
      <Path
        opacity={0.1}
        d="M194.639 92.751s-8.063 8.063-3.511 20.027c4.552 11.963-7.801 31.856-7.801 31.856s.133-.019.386-.061c16.559-2.924 24.786-21.861 15.578-35.931-3.432-5.23-6.242-11.366-4.652-15.89z"
        fill="#000"
      />
      <Path
        d="M194.639 92.616s-4.552 9.882 0 17.945.771 30.689-11.314 33.94"
        stroke="#535461"
        strokeMiterlimit={10}
      />
      <Path
        d="M209 125.226s-9.2-1.465-10.038 6.78c-.839 8.244-17.697 9.386-17.697 9.386l.316.211c13.914 9.134 27.217 5.817 25.21-6.312-.74-4.507-.678-9.036 2.209-10.065z"
        fill="#FFB800"
      />
      <Path
        d="M209 125.226s-7.142 1.567-6.552 8.061c.59 6.495-10.599 14.278-21.175 8.108"
        stroke="#535461"
        strokeMiterlimit={10}
      />
      <Path
        d="M200.906 141.693s-7.245-1.449-9.178-3.382c-1.933-1.933-10.628-5.313-11.594-2.89-.965 2.422-13.042 10.628-4.831 12.077 8.211 1.449 19.323 1.927 21.738.963 2.414-.963 3.865-6.768 3.865-6.768z"
        fill="#A8A8A8"
      />
      <Path
        opacity={0.2}
        d="M175.303 146.594c8.213 1.449 19.323 1.927 21.737.963 1.841-.736 3.118-4.27 3.623-5.916l.241.05s-1.449 5.797-3.864 6.762c-2.414.966-13.526.484-21.737-.963-2.371-.418-3.049-1.401-2.793-2.644.201.811 1.028 1.436 2.793 1.748z"
        fill="#000"
      />
      <Defs>
        <LinearGradient
          id="prefix__paint0_linear"
          x1={109.582}
          y1={150.839}
          x2={109.582}
          y2={11.318}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="gray" stopOpacity={0.25} />
          <Stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <Stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </LinearGradient>
        <LinearGradient
          id="prefix__paint1_linear"
          x1={33733.6}
          y1={47945.5}
          x2={33733.6}
          y2={14434.3}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="gray" stopOpacity={0.25} />
          <Stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <Stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default OrderNotCancelled;
